import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPlus } from "react-icons/fa";



const EditStores = () => {
    const [formData, setFormData] = useState({
        StoreNbr: "",
        StoreShorNname: "",
        Storestatus: "",
        StoreCity: "",
        StoreState: "",
        sourceTenantId: "",
      });
      const navigate = useNavigate();
      
        const [StoreNbr, setStoreNbr] = useState(null);
        
      
        useEffect(() => {
          
          if (!StoreNbr) {
            navigate("/liststores");
          } else {
            setStoreNbr(StoreNbr); 
          }
        }, []);

};

export default EditStores;
